module.exports = __webpack_public_path__ + "static/Image3-f29b74b428e58fafb9f21943f3c133cd.png";